import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormBuilderData } from 'src/types/formBuilder';

export interface MostUsedCategoriesStateType {
  loading: boolean;
  categories: FormBuilderData[];
}

const initialState: MostUsedCategoriesStateType = {
  loading: false,
  categories: [],
};

export const mostUsedCategoriesSlice = createSlice({
  name: 'mostUsedCategories',
  initialState,
  reducers: {
    getMostUsedCategories: () => {},
    setMostUsedCategoriesLoading: (state) => ({ ...state, loading: true }),
    setMostUsedCategories: (state, { payload }: PayloadAction<any[]>) => {
      return {
        ...state,
        loading: false,
        categories: payload,
      };
    },
  },
});

export const {
  getMostUsedCategories,
  setMostUsedCategories,
  setMostUsedCategoriesLoading,
} = mostUsedCategoriesSlice.actions;

export default mostUsedCategoriesSlice.reducer;
